
import React from "react";
import PropTypes from "prop-types";
import "../css/charts.css";

const DonutChart = ({ title, data, labelKey, valueKey, palette = [] }) => {
  if (!data || data.length === 0) return null;

  const renderDonutSlices = () => {
    let currentAngle = 0;
    return data.map((item, index) => {
      const paletteColor =
        Array.isArray(palette) && palette.length ? palette[index % palette.length] : null;
      const angle = (item[valueKey] / 100) * 360;
      const startAngle = currentAngle;
      const endAngle = currentAngle + angle;
      currentAngle = endAngle;

      const startX = 100 + 80 * Math.cos((startAngle - 90) * (Math.PI / 180));
      const startY = 100 + 80 * Math.sin((startAngle - 90) * (Math.PI / 180));
      const endX = 100 + 80 * Math.cos((endAngle - 90) * (Math.PI / 180));
      const endY = 100 + 80 * Math.sin((endAngle - 90) * (Math.PI / 180));
      const largeArc = angle > 180 ? 1 : 0;

      return (
        <path
          key={`slice-${index}`}
          d={`M 100 100 L ${startX} ${startY} A 80 80 0 ${largeArc} 1 ${endX} ${endY} Z`}
          fill={item.color || paletteColor || "#6366F1"}
        />
      );
    });
  };

  return (
    <div className="chart-card">
      <h3 className="chart-title">{title}</h3>
      <div className="donut-chart-container">
        <svg viewBox="0 0 200 200" className="donut-chart">
          {renderDonutSlices()}
          <circle cx="100" cy="100" r="50" fill="white" />
        </svg>
        <div className="donut-legend">
          {data.map((item, index) => (
            <div key={`legend-${index}`} className="legend-item">
              <div
                className="legend-color"
                style={{
                  backgroundColor:
                    item.color ||
                    (Array.isArray(palette) && palette.length
                      ? palette[index % palette.length]
                      : "#6366F1"),
                }}
              />
              <span>
                {item[labelKey]} ({item[valueKey]}%)
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

DonutChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default DonutChart;
